import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { BlockList } from '@udemy/react-core-components';
import { useUDData } from '@udemy/ud-data';
import styles from "./language-selector-menu-item.module.css";
export const LanguageSelectorMenuItem = props => {
  const {
    Config: udConfig
  } = useUDData();
  const {
    gettext,
    locale
  } = useI18n();
  const currentLanguage = React.useMemo(() => {
    const language = udConfig.supported_languages.find(language => language.locale === locale);
    return (language === null || language === void 0 ? void 0 : language.name) || null;
  }, [locale, udConfig.supported_languages]);
  return /*#__PURE__*/React.createElement(BlockList.Item, Object.assign({
    componentClass: "button",
    color: "neutral",
    icon: /*#__PURE__*/React.createElement(Icon, {
      glyph: "language",
      label: false,
      size: "small"
    })
  }, props), /*#__PURE__*/React.createElement("div", {
    className: styles['item-content']
  }, /*#__PURE__*/React.createElement("span", null, gettext('Language')), /*#__PURE__*/React.createElement("span", {
    className: styles['current-language']
  }, currentLanguage)));
};
//# sourceMappingURL=language-selector-menu-item.react-component.js.map